import { render, staticRenderFns } from "./SubHeaderCart.vue?vue&type=template&id=03f0d627&"
import script from "./SubHeaderCart.vue?vue&type=script&lang=js&"
export * from "./SubHeaderCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports